import * as urls from '@/consts/urls'
import AuthentificationService from '@/services/authentification'
import { USER_TYPE_USER, USER_TYPE_ADMIN } from '@/consts/enums'

import LoginPage from '@/components/pages/account/login.vue'
import ForgotPasswordPage from '@/components/pages/account/forgot-password.vue'
import EditMyInformationPage from '@/components/pages/account/edit-my-information.vue'
import ResetPasswordPage from '@/components/pages/account/reset-password.vue'
import SubscribeUserPage from '@/components/pages/account/subscribe-user.vue'
import LogoutPage from '@/components/pages/account/logout.vue'
import ParticipateDashboardPage from '@/components/pages/dashboard/participate-dashboard.vue'
import OrganizeDashboardPage from '@/components/pages/dashboard/organize-dashboard.vue'
import BusinessDashboardPage from '@/components/pages/dashboard/business-dashboard.vue'
import GatheringDashboardPage from '@/components/pages/dashboard/gathering-dashboard.vue'
import StatsDashboardPage from '@/components/pages/dashboard/stats-dashboard.vue'
import SuperAdminDashboardPage from '@/components/pages/dashboard/superadmin-dashboard.vue'
import CreateBusinessPage from '@/components/pages/business/create-business.vue'
import EditBusinessPage from '@/components/pages/business/edit-business.vue'
import CreateGatheringPage from '@/components/pages/gathering/create-gathering.vue'
import EditGatheringPage from '@/components/pages/gathering/edit-gathering.vue'
import GatheringSubmittedPage from '@/components/pages/gathering/gathering-submitted.vue'
import EncouragePage from '@/components/pages/encourage/encourage.vue'
import Error404Page from '@/components/pages/content/error-404.vue'

const DASHBOARD_BASE_URL = '/tableau-de-bord'

// simplifies route config
const anonymous = true
const authenticated = true

/*
meta: {
  anonymous: false, // If true, does not require login
  usertype: null, // set to USER_TYPE_USER or USER_TYPE_ADMIN to restrict page by user type
}
*/

const redirectToDashboard = function() {
  const isLoggedIn = AuthentificationService.getUserIsLogged()
  if (!isLoggedIn) {
    return { name: urls.URL_ACCOUNT_LOGIN }
  }

  const userType = AuthentificationService.getUserType()

  switch (userType) {
    case USER_TYPE_ADMIN:
      return {
        name: urls.URL_ADMIN_BUSINESS_DASHBOARD
      }
    default:
      return {
        name: urls.URL_USER_PARTICIPATE_DASHBOARD
      }
  }
}

// NOTE: On pourrait potentiellement splitter la config de routes en sous-groupes logiques et les combiner ici avec [...someRoutes, ...someOtherRoutes]
export default [
  {
    name: urls.URL_ROOT,
    path: '/',
    redirect() {
      return redirectToDashboard()
    },
    meta: {
      anonymous
    }
  },

  ///////////////////////////
  // Anonyme
  ///////////////////////////
  {
    name: urls.URL_ACCOUNT_LOGIN,
    path: DASHBOARD_BASE_URL + '/connexion',
    component: LoginPage,
    meta: {
      anonymous
    }
  },
  {
    name: urls.URL_ACCOUNT_FORGOT_PASSWORD,
    path: DASHBOARD_BASE_URL + '/mot-de-passe-oublie',
    component: ForgotPasswordPage,
    meta: {
      anonymous
    }
  },
  {
    name: urls.URL_ACCOUNT_EDIT_INFORMATIONS,
    path: DASHBOARD_BASE_URL + '/modifier-mes-informations',
    component: EditMyInformationPage,
    meta: {
      authenticated
    }
  },
  {
    name: urls.URL_ACCOUNT_RESET_PASSWORD,
    path: DASHBOARD_BASE_URL + '/reinitialiser-mot-passe',
    component: ResetPasswordPage,
    meta: {
      anonymous
    }
  },
  {
    name: urls.URL_ACCOUNT_SUBSCRIBE,
    path: DASHBOARD_BASE_URL + '/creer-compte',
    component: SubscribeUserPage,
    meta: {
      anonymous
    }
  },
  {
    name: urls.URL_ENCOURAGE,
    path: '/encourager',
    component: EncouragePage
  },

  ///////////////////////////
  // Account
  ///////////////////////////
  {
    name: urls.URL_USER_DASHBOARD,
    path: DASHBOARD_BASE_URL,
    redirect() {
      return redirectToDashboard()
    },
    meta: {
      authenticated
    }
  },
  {
    name: urls.URL_LOGOUT,
    path: DASHBOARD_BASE_URL + '/deconnexion',
    component: LogoutPage,
    meta: {
      authenticated
    }
  },

  ///////////////////////////
  // Dashboard user
  ///////////////////////////
  {
    name: urls.URL_USER_PARTICIPATE_DASHBOARD,
    path: DASHBOARD_BASE_URL + '/participer',
    component: ParticipateDashboardPage,
    meta: {
      usertype: USER_TYPE_USER,
      authenticated
    }
  },
  {
    name: urls.URL_USER_ORGANIZE_DASHBOARD,
    path: DASHBOARD_BASE_URL + '/organiser',
    component: OrganizeDashboardPage,
    meta: {
      usertype: USER_TYPE_USER,
      authenticated
    }
  },

  ///////////////////////////
  // Dashboard admin
  ///////////////////////////
  {
    name: urls.URL_ADMIN_BUSINESS_DASHBOARD,
    path: DASHBOARD_BASE_URL + '/liste-entreprise',
    component: BusinessDashboardPage,
    meta: {
      usertype: USER_TYPE_ADMIN,
      authenticated
    }
  },
  {
    name: urls.URL_ADMIN_GATHERING_DASHBOARD,
    path: DASHBOARD_BASE_URL + '/liste-rassemblement',
    component: GatheringDashboardPage,
    meta: {
      usertype: USER_TYPE_ADMIN,
      authenticated
    }
  },
  {
    name: urls.URL_ADMIN_STATS_DASHBOARD,
    path: DASHBOARD_BASE_URL + '/statistiques',
    component: StatsDashboardPage,
    meta: {
      usertype: USER_TYPE_ADMIN,
      authenticated
    }
  },
  {
    name: urls.URL_ADMIN_SUPERADMIN_DASHBOARD,
    path: DASHBOARD_BASE_URL + '/super-admin',
    component: SuperAdminDashboardPage,
    meta: {
      usertype: USER_TYPE_ADMIN,
      authenticated
    }
  },

  ///////////////////////////
  // Business
  ///////////////////////////
  {
    name: urls.URL_CREATE_BUSINESS,
    path: DASHBOARD_BASE_URL + '/creer-entreprise',
    component: CreateBusinessPage,
    meta: {
      usertype: USER_TYPE_USER,
      authenticated
    }
  },
  {
    name: urls.URL_EDIT_BUSINESS,
    path: DASHBOARD_BASE_URL + '/editer-entreprise/:id',
    component: EditBusinessPage,
    meta: {
      usertype: USER_TYPE_USER,
      authenticated
    }
  },

  ///////////////////////////
  // Gathering
  ///////////////////////////
  {
    name: urls.URL_CREATE_GATHERING,
    path: DASHBOARD_BASE_URL + '/creer-rassemblement',
    component: CreateGatheringPage,
    meta: {
      usertype: USER_TYPE_USER,
      authenticated
    }
  },
  {
    name: urls.URL_EDIT_GATHERING,
    path: DASHBOARD_BASE_URL + '/editer-rassemblement/:id',
    component: EditGatheringPage,
    meta: {
      usertype: USER_TYPE_USER,
      authenticated
    }
  },
  {
    name: urls.URL_GATHERING_SUBMITTED,
    path: DASHBOARD_BASE_URL + '/rassemblement-soumis/:id',
    component: GatheringSubmittedPage,
    meta: {
      usertype: USER_TYPE_USER,
      authenticated
    }
  },

  ///////////////////////////
  // Content
  ///////////////////////////
  {
    path: '*',
    component: Error404Page
  }
]
